import React from 'react';
import { Checkbox } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
     input_text: {
         fontFamily: "Open Sans Hebrew",
         fontStyle: "normal",
         fontWeight: "normal",
         fontSize: "16px",
         lineHeight: "23px",
         display: "flex",
         alignItems: "center",
         textAlign: "right",
         color: "#111617",
         opacity: 0.7
     },
   });

export function ChildDisabilities(props) {
     const classes = useStyles();
     var no_preference;
     if(props.type == "student"){
          no_preference = <p className={classes.input_text}> <Checkbox defaultChecked={props.user.is_no_preference} name="is_no_preference" value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> אין העדפה </p>
     }
  return(
    <div align="right" >
          {no_preference}
          <p className={classes.input_text}> <Checkbox defaultChecked={props.user.is_autistic_spectrum} name="is_autistic_spectrum" value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן על הספקטרום האוטיסטי </p>
          <p className={classes.input_text}> <Checkbox name="is_intellectual_limitation" defaultChecked={props.user.is_intellectual_limitation} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם מוגבלות שכלית </p>
          <p className={classes.input_text}> <Checkbox name="is_delayed_developed" defaultChecked={props.user.is_delayed_developed} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם עיכוב התפתחותי </p>
          <p className={classes.input_text}> <Checkbox name="is_physical_limitation" defaultChecked={props.user.is_physical_limitation} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם מוגבלות פיזית </p>
          <p className={classes.input_text}> <Checkbox name="is_behavioral_difficulty" defaultChecked={props.user.is_behavioral_difficulty} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מתמודד עם קשיים התנהגותיים </p>
          <p className={classes.input_text}> <Checkbox name="is_nursing_assistance" defaultChecked={props.user.is_nursing_assistance} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> נדרש סיוע סיעודי </p>
               <p className={classes.input_text}> <Checkbox name="is_medical_assistance" defaultChecked={props.user.is_medical_assistance} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> נדרש סיוע רפואי </p>
               <p className={classes.input_text}> <Checkbox name="is_other" defaultChecked={props.user.is_other} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> אחר</p>
    </div>
  );
}

export function ExtraChildDisabilities(props) {
     const classes = useStyles();
  return(
    <div align="right" >
          <p className={classes.input_text}> <Checkbox defaultChecked={props.user.extra_child.is_autistic_spectrum} name="is_autistic_spectrum" value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן על הספקטרום האוטיסטי </p>
          <p className={classes.input_text}> <Checkbox name="is_intellectual_limitation" defaultChecked={props.user.extra_child.is_intellectual_limitation} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם מוגבלות שכלית </p>
          <p className={classes.input_text}> <Checkbox name="is_delayed_developed" defaultChecked={props.user.extra_child.is_delayed_developed} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם עיכוב התפתחותי </p>
          <p className={classes.input_text}> <Checkbox name="is_physical_limitation" defaultChecked={props.user.extra_child.is_physical_limitation} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מאובחן עם מוגבלות פיזית </p>
          <p className={classes.input_text}> <Checkbox name="is_behavioral_difficulty" defaultChecked={props.user.extra_child.is_behavioral_difficulty} value="secondary" color="primary"
               inputProps={{ 'aria-label': 'secondary checkbox' }}/> מתמודד עם קשיים התנהגותיים </p>
          <p className={classes.input_text}> <Checkbox name="is_nursing_assistance" defaultChecked={props.user.extra_child.is_nursing_assistance} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> נדרש סיוע סיעודי </p>
               <p className={classes.input_text}> <Checkbox name="is_medical_assistance" defaultChecked={props.user.extra_child.is_medical_assistance} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> נדרש סיוע רפואי </p>
               <p className={classes.input_text}> <Checkbox name="is_other" defaultChecked={props.user.extra_child.is_other} value="secondary" color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}/> אחר</p>
    </div>
  );
}
